<app-widget-base-detail [baseDetailComponent]="this"/>